import { opacifyHex } from '@myre/common-primitives';
import { COLOR_NEUTRAL_NINE } from '@myre/common-styles';

import { type ChartDataset } from 'chart.js';

import { type ChartType } from '../enums';

import { CANVAS_PADDING } from './constants';
import { type Doughnut } from './doughnut.component';

/**
 * Depending on the requested color, for every color, we generate the corresponding colors for borders, hovers, and others.
 */
export function dataSetDoughnutStyle(
  data: Doughnut[],
): Partial<ChartDataset<ChartType.Doughnut>> {
  return {
    backgroundColor: data.map(d => opacifyHex(d.color, 0.6)),
    borderColor: data.map(d => opacifyHex(d.color, 1)),
    borderWidth: 1,
    // zoom effect on hover, the level of zoom cannot exceed the boundaries of the canvas padding
    hoverOffset: CANVAS_PADDING,
    hoverBorderColor: COLOR_NEUTRAL_NINE,
    hoverBackgroundColor: data.map(d => opacifyHex(d.color, 1)),
  };
}
